import Axios, { AxiosRequestConfig, AxiosError } from "axios";
import AxiosService from "../axiosService";
import config from "@src/utilities/config";
import { apiLogger } from "../workers/helpers";
import Version from "@utils/version";
import { cacheConfig } from "./cacheConfig";

const namespace = "CCM API Axios Service";

export const axiosAPIClient = new AxiosService(`${config.api.careClub}/`, apiLogger, namespace, true, cacheConfig);

export const AXIOS_INSTANCE = axiosAPIClient.getAxiosInstance();

const addCustomHeaders = (request: any) => {
  request.headers["UserId"] = axiosAPIClient.user?.profile?.user_id;
  request.headers["ApplicationId"] = Version.getApplicationId();
}

// add axios request interceptor to add custom headers
axiosAPIClient.addRequestInterceptor(
  (request: any) => {
    addCustomHeaders(request);
    return request;
  },
  (error: any) => {
    return Promise.reject(error);
  }
);

// add a second `options` argument here if you want to pass extra options to each generated query
export const customInstance = <T>(config: AxiosRequestConfig, options?: AxiosRequestConfig): Promise<T> => {
  const source = Axios.CancelToken.source();
  const promise: Promise<T> = AXIOS_INSTANCE({
    ...config,
    ...options,
    cancelToken: source.token,
  }).then(({ data }) => data);

  // @ts-ignore
  promise.cancel = () => {
    source.cancel("Query was cancelled");
  };
  return promise;
};

// In some case with react-query and swr you want to be able to override the return error type so you can also do it here like this
export type ErrorType<Error> = AxiosError<Error>;
// In case you want to wrap the body type (optional)
// (if the custom instance is processing data before sending it, like changing the case for example)
export type BodyType<BodyData> = BodyData;
